// Mock data voor WS GLOBAL TRADING (frontend-only)

export const brands = [
  { name: "JBL", logo: "/images/brands/jbl.svg" },
  { name: "Sony", logo: "/images/brands/sony.svg" },
  { name: "Microsoft", logo: "/images/brands/microsoft.svg" },
  { name: "Logitech", logo: "/images/brands/logitech.svg" },
  { name: "Bose", logo: "/images/brands/bose.svg" },
  { name: "Apple", logo: "/images/brands/apple.svg" },
  { name: "Samsung", logo: "/images/brands/samsung.svg" },
];

// Generieke productcategorieën (geen merk- of productnamen)
export const categories = [
  { name: "Smartphones", icon: "Smartphone", image: "/images/categories/smartphones.jpg", tagline: "Flagship- en mid-range toestellen" },
  { name: "Audio", icon: "Headphones", image: "/images/categories/audio.jpg", tagline: "Koptelefoons, oordopjes & speakers" },
  { name: "Wearables", icon: "Watch", image: "/images/categories/wearables.png", tagline: "Smartwatches & fitness trackers" },
  { name: "Smart Home", icon: "Home", image: "/images/categories/smart-home.jpg", tagline: "Slimme speakers & huisautomatisering" },
  { name: "Laptops & tablets", icon: "Laptop", image: "/images/categories/laptops.jpg", tagline: "Voor werk, school en thuis" },
  { name: "Gaming", icon: "Gamepad2", image: "/images/categories/gaming.png", tagline: "Consoles & accessoires" },
];

export const globeImage = "/images/misc/globe-earth.avif";
export const capabilitiesImage = "/images/misc/capabilities-flatlay.jpg";

// Drie pijlers van ons wereldwijde netwerk
export const networkFeatures = [
  {
    icon: "Network",
    title: "Wereldwijde sourcing",
    text: "We sourcen A-merk consumentenelektronica via een vertrouwd netwerk van geautoriseerde distributeurs en fabrikanten, wereldwijd.",
  },
  {
    icon: "Boxes",
    title: "Slimme distributie",
    text: "Door orders te consolideren realiseren we schaalvoordeel: sterkere voorwaarden en consistente beschikbaarheid.",
  },
  {
    icon: "TrendingUp",
    title: "Marktkennis in real-time",
    text: "Onze accountmanagers volgen vraag en prijzen op de voet, zodat we snel kunnen inspelen op marktbewegingen.",
  },
];

// Capaciteiten / diensten (vervangt de kopers/leveranciers-tender accordions)
export const capabilities = [
  {
    title: "Kwaliteit staat centraal",
    text: "We werken uitsluitend met geautoriseerde distributeurs en fabrikanten, en controleren elke zending op kwaliteit voordat deze wordt geleverd.",
  },
  {
    title: "Eén aanspreekpunt, altijd",
    text: "Geen losse partijen om te beheren. Bij WS Global Trading heb je altijd één vast aanspreekpunt voor sourcing, logistiek en support.",
  },
  {
    title: "Flexibele voorwaarden",
    text: "Van betalingstermijnen tot leveringsschema's: we stemmen onze voorwaarden af op wat werkt voor jouw business.",
  },
];

// Vier stappen van samenwerken (vervangt het tender-proces)
export const processSteps = [
  {
    step: "STAP 1",
    title: "Vertel ons wat je zoekt",
    text: "Deel je productcategorie, gewenste volumes en wensen. Wij denken vanaf dag één met je mee.",
  },
  {
    step: "STAP 2",
    title: "Wij sourcen wereldwijd",
    text: "Ons netwerk van geautoriseerde distributeurs en fabrikanten gaat voor jou aan de slag, wereldwijd.",
  },
  {
    step: "STAP 3",
    title: "Kwaliteitscontrole & consolidatie",
    text: "Elke zending wordt gecontroleerd en waar mogelijk gebundeld voor de scherpste voorwaarden.",
  },
  {
    step: "STAP 4",
    title: "Snel en betrouwbaar geleverd",
    text: "Rechtstreeks naar jouw magazijn, met de betalingsvoorwaarden die bij jouw business passen.",
  },
];

export const companyInfo = {
  name: "WS Global Trading",
  address: "Transportweg 15",
  postal: "2742 RH Waddinxveen",
  email: "info@wsglobaltrading.nl",
};

// LocalStorage helpers voor mock formulier-inzendingen
export const saveSubmission = (key, data) => {
  try {
    const existing = JSON.parse(localStorage.getItem(key) || "[]");
    existing.push({ ...data, submittedAt: new Date().toISOString() });
    localStorage.setItem(key, JSON.stringify(existing));
    return true;
  } catch (e) {
    return false;
  }
};
